import {useQuery} from '@tanstack/react-query';
import { authorizedGet } from '../functions/AuthService';

export const useAllForecasts = () => {
    return useQuery({
        queryKey: ['forecasts', 'all'],
        queryFn: async () => {
            const response = await authorizedGet("/forecast/getAll");
            return await response.body.json();
        },
        staleTime: 1000 * 60 * 60, //1 hour
    });
}
    
export const useForecastJSON = (prefix, type, enabled = false) => {
    return useQuery({
        queryKey: ['forecasts', 'json', prefix, type],
        queryFn: async () => {
            const response = await authorizedGet(`/forecast/getJSON/${prefix}${type}.json`);
            return await response.body.json();
        },
        enabled: enabled && !!prefix && !!type,
        staleTime: 1000 * 60 * 60 * 10 //10 hours
    });
}